
  var _styles = {
  "subscribe-button-wrapper": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "subscribe-button": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "backgroundColor": "rgba(0,0,0,0)",
    "borderRadius": "1.06667rem"
  },
  "subscribe-button-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "lineHeight": "0.64rem"
  }
};



  module.exports = _styles;
  